export default "__VITE_ASSET__6e58c524__"